/* eslint-disable jsx-a11y/iframe-has-title */
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Img from '@src/components/Img';

import useStyles from 'isomorphic-style-loader/useStyles';
import css from './style.module.sass';

const MediaBigPhoto = (props) => {
	useStyles(css);
	const { img, video, onLoad, mix, onLoadStart } = props;

	if (!(img || video)) return null;

	return (
		<div className={cn(css.wrap, mix)}>
			{img && (
				<Img
					key={img.src}
					imgClassName={css.img}
					forceVisibility
					tail="=w1500-h1000-l95-e31"
					isImg
					{...img}
					onLoad={onLoad}
					onLoadStart={onLoadStart}
				/>
			)}

			{video && (
				<div
					className={css.video}
					style={{ aspectRatio: `${video.width} / ${video.height}` }}
				>
					<iframe
						className={css.iframe}
						src={video.src}
						width={video.width}
						height={video.height}
						allowFullScreen
					/>
				</div>
			)}
		</div>
	);
};

MediaBigPhoto.propTypes = {
	img: PropTypes.shape(Img.type.propTypes),
	video: PropTypes.shape({
		src: PropTypes.string,
		width: PropTypes.number,
		height: PropTypes.number,
	}),
	onLoad: PropTypes.func,
	onLoadStart: PropTypes.func,
	mix: PropTypes.string,
};

MediaBigPhoto.defaultProps = {
	img: undefined,
	video: undefined,
	onLoad: undefined,
	onLoadStart: undefined,
	mix: undefined,
};

export default MediaBigPhoto;
